import Seo from "@/components/site/Seo";
import PageHeader from "@/components/site/PageHeader";
import VisionBlock from "@/components/sections/VisionBlock";
import WhySection from "@/components/sections/WhySection";
import Marquee from "@/components/site/Marquee";
import StayInLoop from "@/components/sections/StayInLoop";
import { IMG } from "@/lib/content";

export default function Vision() {
  return (
    <>
      <Seo title="The Vision — RestPower" description="As vehicles become electric, the places where travelers stop should evolve too. Explore the RestPower vision for the next generation of the road trip." path="/vision" />
      <PageHeader
        overline="The Vision"
        title={<>The Next Generation of the Road Trip.</>}
        intro="Transportation is changing, but the roadside experience has largely remained the same. RestPower was created around a simple idea: as vehicles become electric, the places where travelers stop should evolve too."
        image={IMG.lounge}
        concept
      />
      <VisionBlock withCta={false} />
      <Marquee items={["Clean Energy", "Comfort", "Convenience", "Hospitality"]} />
      <WhySection />
      <StayInLoop />
    </>
  );
}
